<template>
  <div class="personal-center-page">
    <!-- 头部banner区域 -->
    <div class="header-banner">
      <div class="banner-content">
        <img
          src="@/assets/college/bg-banner.png"
          class="banner-image"
        />
        <!-- 页面标题 -->
        <div class="page-header">
          <h1 class="page-title">个人中心</h1>
        </div>
      </div>
    </div>

    <!-- 金色banner卡片 -->
    <div class="golden-banner">
      <img
        src="@/assets/college/vip-card/card.png"
        alt="卡片背景"
        class="card-background"
      />
      <img
        :src="collegeName[productId].logoCard"
        alt="logo"
        class="logo-image"
      />
      <img
        src="@/assets/college/vip-card/vip.png"
        alt="vip"
        class="vip-image"
      />
      <img
        src="@/assets/college/vip-card/super.png"
        alt="super"
        class="super-image"
      />
      <img
        src="@/assets/college/vip-card/text.png"
        alt="text"
        class="text-image"
      />
      <div class="vip-card-text" @click="goToRightsDetail">
        <span>查看权益</span>
      </div>
    </div>

    <!-- 我的操作区域 -->
    <div class="operations-section">
      <div class="section-title-row">
        <h3 class="section-title">我的操作</h3>
        <div class="back-action" @click="goBackToList">
          <van-icon name="revoke" size="18px" />
          <span>返回列表</span>
        </div>
      </div>
      <div class="operation-icons">
        <div
          v-for="item in visibleOperations"
          :key="item.action"
          class="operation-item"
          @click="handleOperationClick(item.action)"
          v-show="item.show"
        >
          <div class="icon-circle">
            <img :src="item.icon" :alt="item.label" class="operate-icon" />
          </div>
          <span class="icon-label">{{ item.label }}</span>
        </div>
      </div>
    </div>

    <!-- 退出登录按钮 -->
    <div class="logout-section">
      <button class="logout-btn" @click="handleLogout">退出登录</button>
    </div>

    <!-- 联系我们弹层 -->
    <van-popup
      v-model="showContactSheet"
      position="bottom"
      round
      :close-on-click-overlay="true"
      class="contact-popup"
    >
      <div class="contact-sheet">
        <button class="contact-call-btn" @click="handleCallPhone">
          <van-icon name="phone" size="24" color="#07c160" class="phone-icon" />
          <div class="call-text">
            <div class="call-number">呼叫 {{ contactPhone }}</div>
            <div class="work-time">工作时间: 工作日9:00-19:00</div>
          </div>
        </button>
        <button class="contact-cancel-btn" @click="showContactSheet = false">
          取消
        </button>
      </div>
    </van-popup>

    <!-- 实时查看视频弹窗 -->
    <van-popup
      v-model="showVideoPlayer"
      position="center"
      :close-on-click-overlay="false"
      :overlay="true"
      :closeable="false"
      class="video-popup"
      @close="onVideoPopupClose"
    >
      <div class="video-player-wrapper">
        <div class="video-header">
          <div class="video-title-text">实时查看</div>
          <van-icon name="cross" class="close-icon" @click="closeVideoPlayer" />
        </div>
        <div class="video-content">
          <video
            ref="videoPlayer"
            :src="videoUrl"
            autoplay
            loop
            playsinline
            webkit-playsinline
            class="video-player"
            @loadedmetadata="onVideoLoaded"
          ></video>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import operateIcon1 from "@/assets/client/operate_icon_1.png";
import operateIcon2 from "@/assets/client/operate_icon_2.png";
import operateIcon3 from "@/assets/client/operate_icon_3.png";
import operateIcon4 from "@/assets/client/operate_icon_4.png";
import { college } from "../../college/config";

export default {
  name: "ClientPersonalCenter",
  data() {
    return {
      collegeName: college,
      productId: '0',
      orgName: "",
      showContactSheet: false,
      contactPhone: "400-660-0808",
      personPrivilgeId: this.$route.query.personPrivilgeId || "",
      privilegeName: this.$route.query.privilegeName || "",
      biaoJi: this.$route.query.biaoJi || "",
      // 视频播放相关
      showVideoPlayer: false,
      videoUrl:
        "https://morehealthy.oss-cn-beijing.aliyuncs.com/cunchuguan/cunchuguan04.mp4",
      operations: [
        {
          label: "证书查询",
          icon: operateIcon1,
          action: "goToCertificate",
          show: true
        },
        {
          label: "实时查看",
          icon: operateIcon2,
          action: "goToRealTime",
          show: true
        },
        {
          label: "联系我们",
          icon: operateIcon3,
          action: "goToContact",
          show: true
        },
        // {
        //   label: "知情同意书",
        //   icon: operateIcon4,
        //   action: "goToConsent",
        // },
      ],
    };
  },
  computed: {
    visibleOperations() {
      // 所有操作都显示，不再过滤
      return this.operations;
    },
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search);
    this.productId = this.$route.meta.productId || urlParams.get("productId") || localStorage.getItem("productId") || "18";

    if (this.productId !== '0') {
      this.operations[1].show = false
    }
  },
  mounted() {
    this.orgName = localStorage.getItem("client_user");
  },
  methods: {
    goToCertificate() {
      if (!this.personPrivilgeId) {
        this.$toast("缺少权益信息，无法查询证书");
        return;
      }
      this.$router.push({
        path: "/jiaJiHua/certificate",
        query: {
          personPrivilgeId: this.personPrivilgeId,
          productId: this.productId,
        },
      });
    },
    goToRealTime() {
      // 显示视频播放弹窗
      this.showVideoPlayer = true;
    },
    closeVideoPlayer() {
      this.showVideoPlayer = false;
      this.stopVideo();
    },
    onVideoPopupClose() {
      this.stopVideo();
    },
    stopVideo() {
      const video = this.$refs.videoPlayer;
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    },
    onVideoLoaded() {
      const video = this.$refs.videoPlayer;
      if (video) {
        video.volume = 1;
        video.muted = false;
        video.play().catch((error) => {
          console.log("自动播放失败，可能需要用户交互", error);
          // 如果自动播放失败，尝试静音播放后再取消静音
          video.muted = true;
          video
            .play()
            .then(() => {
              // 播放成功后，取消静音
              video.muted = false;
            })
            .catch((err) => {
              console.log("静音自动播放也失败", err);
            });
        });
      }
    },
    goToContact() {
      this.showContactSheet = true;
    },
    goToRightsDetail() {
      // 从路由参数获取权益信息
      this.$router.push({
        path: "/jiaJiHua/rightsDetail",
        query: {
          personPrivilgeId: this.personPrivilgeId,
          privilegeName: this.privilegeName,
          productId: this.productId,
        },
      });
    },
    handleCallPhone() {
      // 拨打电话
      window.location.href = `tel:${this.contactPhone.replace(/-/g, "")}`;
      this.showContactSheet = false;
    },
    goToConsent() {
      this.$router.push({
        path: "/jiaJiHua/consent",
        query: {
          personPrivilgeId: this.personPrivilgeId,
          productId: this.productId,
        },
      });
    },
    handleOperationClick(action) {
      // 如果是证书查询操作，需要检查 biaoJi 是否存在
      if (action === "goToCertificate" && !this.biaoJi) {
        this.$toast("证书还未生成，请等待");
        return;
      }

      if (action && typeof this[action] === "function") {
        this[action]();
      }
    },
    goBackToList() {
      this.$router.push({
        path: "/jiaJiHua",
        query: {
          productId: this.productId,
        },
      });
    },
    handleLogout() {
      this.$dialog
        .confirm({
          title: "确认退出",
          message: "确定要退出登录吗？",
        })
        .then(() => {
          // 清除本地存储（使用客户端系统的key）
          localStorage.removeItem("client_token");
          localStorage.removeItem("client_user");

          this.$toast("已退出登录");

          // 跳转到登录页
          this.$router.push({
            path: "/jiaJiHua/login",
            query: {
              productId: this.productId,
            },
          });
        })
        .catch(() => {
          // 用户取消
        });
    },
  },
  watch: {
    "$route.query.personPrivilgeId"(val) {
      this.personPrivilgeId = val || "";
    },
    "$route.query.biaoJi"(val) {
      this.biaoJi = val || "";
    },
  },
};
</script>

<style scoped lang="less">
.personal-center-page {
  min-height: 100vh;
  background: #fff;
  position: relative;
  padding-bottom: 90px; /* 为固定的退出按钮留出空间 */
}

/* 头部banner区域 */
.header-banner {
  position: relative;
  height: 245px;
  overflow: hidden;
}

.section-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.back-action {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #bb7849;
  padding: 6px 12px;
  border-radius: 16px;
  background: rgba(255, 243, 226, 0.88);
  box-shadow: 0 2px 6px rgba(255, 179, 71, 0.25);
}

.back-action:active {
  opacity: 0.85;
}

.banner-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.banner-content {
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  align-items: center;
}

/* 页面标题 */
.page-header {
  position: absolute;
  top: 20px;
  left: 0;
  right: 0;
  z-index: 3;
  text-align: center;
}

.page-title {
  color: white;
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}

/* 金色banner卡片 */
.golden-banner {
  position: relative;
  z-index: 2;
  padding: 0 20px 20px;
  margin-top: -160px;
}

.card-background {
  width: 100%;
  height: auto;
  display: block;
}
.logo-image {
  position: absolute;
  width: 200px;
  left: 40px;
  top: 20px;
}
.text-image {
  position: absolute;
  width: 280px;
  left: 40px;
  top: 80px;
}
.super-image {
  position: absolute;
  width: 50px;
  left: 40px;
  top: 115px;
}
.vip-image {
  position: absolute;
  width: 30px;
  left: 95px;
  top: 111px;
}
.vip-card-text {
  position: absolute;
  right: 40px;
  top: 145px;
  padding: 7px 10px;
  border-radius: 3px;
  background: linear-gradient(
    268deg,
    rgba(245, 196, 133, 1) 0.61%,
    rgba(254, 221, 189, 1) 97.34%
  );
  color: rgb(126, 86, 33);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  user-select: none;
}

.vip-card-text:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.vip-card-text:active {
  transform: scale(0.98);
}

/* 我的操作区域 */
.operations-section {
  padding: 0 20px 30px 20px;
  background: white;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 20px 0;
}

.operation-icons {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 40px;
  row-gap: 30px;
}

.operation-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: transform 0.3s;
  flex: 0 0 auto;
}

.operation-item:hover {
  transform: translateY(-5px);
}

.icon-circle {
  width: 80px;
  height: 80px;
  background: linear-gradient(
    -57.77deg,
    rgba(246, 201, 144, 1) 9.65%,
    rgba(253, 218, 181, 1) 89.45%
  );
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  box-shadow: 0 4px 15px rgba(212, 175, 55, 0.3);
  img {
    width: 47px;
    height: 47px;
  }
}

.icon-label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

/* 退出登录按钮 */
.logout-section {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  /* background: white; */
  /* box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); */
  z-index: 100;
}

.logout-btn {
  width: 100%;
  height: 50px;
  background: linear-gradient(
    -57.77deg,
    rgba(246, 201, 144, 1) 9.65%,
    rgba(253, 218, 181, 1) 89.45%
  );
  border: none;
  border-radius: 25px;
  color: #8b4513;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 15px rgba(212, 175, 55, 0.3);
}

.logout-btn:hover {
  background: linear-gradient(135deg, #c19b2e 0%, #e6c035 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(212, 175, 55, 0.4);
}

.logout-btn:active {
  transform: translateY(0);
}

/* 响应式设计 */
@media (max-width: 375px) {
  .header-banner {
    height: 200px;
  }

  .golden-banner {
    padding: 0 15px 15px;
  }

  .icon-circle {
    width: 70px;
    height: 70px;
  }

  .operation-icons {
    gap: 10px;
  }
}

/* 联系我们弹层样式 */
.contact-popup {
  z-index: 2000;
}

.contact-sheet {
  padding: 12px 16px 20px;
  background: transparent;
}
::v-deep .van-popup {
  background: transparent;
}
.contact-call-btn {
  width: 100%;
  background: white;
  border: none;
  border-radius: 12px;
  padding: 24px 20px;
  margin-bottom: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  min-height: 90px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.2s;
}

.contact-call-btn:active {
  background: #f5f5f5;
  transform: scale(0.98);
}

.phone-icon {
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  flex-shrink: 0;
}

.call-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: 100%;
  margin: 0 auto;
}

.call-number {
  font-size: 18px;
  font-weight: bold;
  color: #07c160;
  margin-bottom: 6px;
  text-align: center;
  line-height: 1.4;
}

.work-time {
  font-size: 12px;
  color: #999;
  font-weight: normal;
  text-align: center;
  line-height: 1.4;
}

.contact-cancel-btn {
  width: 100%;
  background: white;
  border: none;
  border-radius: 12px;
  padding: 18px 16px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  color: #ee0a24;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.2s;
}

.contact-cancel-btn:active {
  background: #f5f5f5;
  transform: scale(0.98);
}

/* 视频播放弹窗样式 */
::v-deep .video-popup {
  background: transparent !important;
  width: 100% !important;
  height: 100% !important;
  max-width: 100% !important;
  max-height: 100% !important;
  border-radius: 0 !important;
}

::v-deep .video-popup .van-popup {
  width: 100vw !important;
  height: 100vh !important;
  max-width: 100vw !important;
  max-height: 100vh !important;
  left: 0 !important;
  top: 0 !important;
  transform: none !important;
  border-radius: 0 !important;
  background: transparent !important;
}

.video-player-wrapper {
  width: 100vw;
  height: 100vh;
  max-width: 100vw;
  max-height: 100vh;
  background: #000;
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 0;
  padding: 0;
}

.video-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1;
}

.video-title-text {
  flex: 1;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 15px;
}

.close-icon {
  font-size: 24px;
  color: #fff;
  cursor: pointer;
  flex-shrink: 0;
}

.video-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.video-player {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}
</style>
